(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('VaccinationSearch', VaccinationSearch);

    VaccinationSearch.$inject = ['$resource'];

    function VaccinationSearch($resource) {
        var resourceUrl =  'api/_search/vaccinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
